export default {
    pageLength: 'تعداد در صفحه',
    of: 'از',

}